
import { debugLog, DebugLevel } from "@/utils/debugUtils";

/**
 * Handles clearing word errors
 */
export const clearWordError = (
  wordError: string,
  setWordError: (error: string) => void
) => {
  if (wordError) {
    debugLog(DebugLevel.INFO, "wordSubmission", "Clearing word error state");
    setWordError("");
  }
};

/**
 * Determines if the submission is eligible for processing
 */
export const isSubmissionEligible = (
  userHasSubmitted: boolean, 
  isProcessingError: boolean,
  gameOver: boolean
): boolean => {
  if (userHasSubmitted || isProcessingError || gameOver) {
    debugLog(
      DebugLevel.INFO, 
      "wordSubmission", 
      `Ignoring submission: already submitted=${userHasSubmitted}, processing error=${isProcessingError}, game over=${gameOver}`
    );
    return false;
  }
  return true;
};
